<template>
    <div>
        <div
            :class="['drag-area-hidden-frame', { 'drag-area-hidden-frame_dragging': dragging }]"
            @drop.prevent="addFiles"
            @dragenter.prevent="dragenter"
            @dragleave.prevent="dragleave"
        ></div>
        <div :class="['drag-area', { 'drag-area_dragging': dragging }, { 'drag-area_active': active }]">
            {{ text }}
        </div>
    </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex';

export default {
    name: 'DragArea',

    props: {
        text: {
            type: String,
            default: 'Drop files here',
        },
    },

    data() {
        return {
            active: false,
        };
    },

    computed: {
        ...mapState({
            dragging: state => state.dragging,
        }),
    },

    methods: {
        ...mapActions({
            stopDragging: 'stopDragging',
            setDroppedFiles: 'setDroppedFiles',
            startDropAllowing: 'startDropAllowing',
            stopDropAllowing: 'stopDropAllowing',
        }),

        addFiles(e) {
            let droppedFiles = e.dataTransfer.files;

            this.active = false;
            this.stopDragging();
            this.stopDropAllowing();
            this.$emit('onDropFiles', droppedFiles);
        },
        dragenter() {
            this.active = true;
            this.startDropAllowing();
        },
        dragleave() {
            this.active = false;
            this.stopDropAllowing();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/_colors.scss';

.drag-area {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(rgba($gray-background, 1), rgba($gray-background, 1));
    background-color: $gray-background;
    border: 1px dashed rgba($drop-zone-gray-color, 0.5);
    border-radius: 4px;
    font-size: 18px;
    color: $primary-dark;
    font-weight: 500;
    pointer-events: none;
    z-index: 1;
    opacity: 0;
    &_dragging {
        opacity: 1;
    }

    &_active {
        background-image: linear-gradient(rgba($primary-green, 0.1), rgba($primary-green, 0.1));
        border: 2px dashed $primary-green;
        color: $drop-zone-gray-color;
    }
}
.drag-area-hidden-frame {
    position: absolute;
    top: 0;
    left: 0;
    width: 105%;
    height: 200%;
    margin: -5% 0 0 -2%;
    z-index: 1;
    display: none;
    &_dragging {
        display: block;
    }
}
</style>
